import { useEffect } from "react"

import { useHealthActions } from "app/health/useHealthActions"

// import { useProjects } from "data/projects/useProjects"

// import {
//   usePriceHealthQuery,
//   useProductConfigurationHealthQuery,
//   useProductInformationHealthQuery,
//   useProjectsHealthQuery
// } from "shared/types/__generated__/graphql"

// import { useAuth } from "./useAuth"

export function useAPIHealthMonitor(/** pollInterval?: number */) {
  const { setAPIHealth } = useHealthActions()
  // const { isAuthenticated } = useAuth()

  // const { error: isProjectsServiceUnavailable } = useProjectsHealthQuery({
  //   pollInterval,
  //   skip: !isAuthenticated
  // })

  // const { error: projectsQueryError } = useProjects()

  // const { error: isPriceServiceUnavailable } = usePriceHealthQuery({
  //   pollInterval,
  //   skip: !isAuthenticated
  // })

  // const { error: isProductConfigurationUnavailable } =
  //   useProductConfigurationHealthQuery({
  //     pollInterval
  //   })

  // const { error: isProductInformationUnavailable } =
  //   useProductInformationHealthQuery({
  //     pollInterval,
  //     skip: !isAuthenticated
  //   })

  useEffect(
    () => {
      setAPIHealth({
        endpointHealth: {
          projects: true, // !isProjectsServiceUnavailable && !projectsQueryError,
          price: true, // !isPriceServiceUnavailable,
          productConfiguration: true, // !isProductConfigurationUnavailable,
          productInformation: true // !isProductInformationUnavailable
        }
      })
    },
    [
      // projectsQueryError,
      // isProjectsServiceUnavailable,
      // isPriceServiceUnavailable,
      // isProductConfigurationUnavailable,
      // isProductInformationUnavailable
    ]
  )
}
